module.exports = __webpack_public_path__ + "static/media/23_l_stena_0_0.4e382bc8.png";